import React, { useCallback } from 'react';
import { Button } from '@material-ui/core';
import useHasPrivilege from '../../Util/useHasPrivilege';
import { Privilege } from '../../../api';
import styled from 'styled-components';
import { useHistory } from 'react-router';

type Props = {
  sessionId: string;
};

const SessionAddLabelTaskButton = (props: Props) => {
  const hasExportPermission = useHasPrivilege(Privilege.ExportData);
  let history = useHistory();
  
  const gotoAdd = useCallback(() => {
    history.push('/session/label/' + props.sessionId + "/add");
  }, [history, props.sessionId]);

  return hasExportPermission ?
    <Container>
      <Button 
        variant="contained" 
        style={{backgroundColor: "#090", color: "#fff", }}
        onClick={gotoAdd}
      >
        Add New Task
      </Button>
    </Container>
    : <></>;
};

const Container = styled.div`
  border-top: 1px solid darkgray;
  padding-top: 16px;
  margin-top: 16px;
  display: flex;
  flex-direction: column;
`;

export default SessionAddLabelTaskButton;